import _ from 'lodash';
const isOverflow = (element) => {
  return element.clientWidth < element.scrollWidth;
};

const isPositionStickySupported = () => {
  if (window) {
    const el = document.createElement('div');

    el.style.cssText = 'position:sticky;position:-webkit-sticky;position:-ms-sticky';

    return el.style.position.indexOf('sticky') !== -1;
  }

  return false;
};

const generateStyles = (wrapper, styleList) => {
  let wrappedStyles = '';

  _.forEach(styleList, (element) => {
    wrappedStyles += wrapper + " " + element.selector + "{" + element.styles + "} ";
  });

  return wrappedStyles;
};

const checkIOSDevice = () => {
  return (typeof navigator === 'object') ? navigator.userAgent.match(/iPad|iPhone|iPod/i) : false;
};

export { isOverflow, isPositionStickySupported, generateStyles, checkIOSDevice };



// WEBPACK FOOTER //
// ./app/utils/DOMUtils.js